import { Map } from "immutable"
import { Observable } from "rxjs/Observable"

import {
    COMMUNITY_LIST_REQUEST,
    COMMUNITY_LIST_RESPONSE,
    COMMUNITY_LIST_CACHED_RESPONSE,
    COMMUNITY_LIST_SEARCH_REQUEST,
    COMMUNITY_APPLY_FILTER_CRITERIA,
    COMMUNITY_ITEM_SAVE_REQUEST,
    COMMUNITY_ITEM_SAVE_RESPONSE,
    COMMUNITY_ITEM_REQUEST,
    COMMUNITY_ITEM_RESPONSE,
    COMMUNITY_ITEM_CACHED_RESPONSE,
    COMMUNITY_APPLY_MODEL_UPDATE,
    COMMUNITY_CANCEL_MODEL_UPDATE,
    COMMUNITY_ADD_NEW
} from "../actions/action-types"
import {
    communitySetEditMode,
    communityListRequest,
    communityListCachedResponse,
    communityListResponse,
    communityListErrorResponse,
    communityItemSaveRequest,
    communityItemSaveResponse,
    communityItemRequest,
    communityItemResponse,
    communityItemCachedResponse,
    communityItemErrorResponse
} from "../actions/community-actions"
import {
    communityParticipantListRequest,
    communityParticipantListInvalidation
} from "../actions/community-participant-actions"
import {
    getCommunityList,
    getCommunityItem,
    putCommunityItem,
    postCommunityItem
} from "../api/community-api"
import {
    hydrate as hydrateCommunity,
    normalisingFields,
    toAPI as communityToAPI
} from "../models/entities/community"
import { defaultSearchCriteria } from "../reducers/paging/community-paging-reducer"
import {
    requestListEpic,
    requestListSearchEpic,
    requestListFilterEpic,
    requestItemEpic,
    requestItemSaveEpic,
    requestTopItemFromListResponseEpic,
    syncIdToURLEpic
} from "./default-epics/default-entity-epics"

export const requestCommunityListEpic = requestListEpic(
    COMMUNITY_LIST_REQUEST,
    getCommunityList,
    "communities",
    communityListResponse,
    communityListCachedResponse,
    communityListErrorResponse
)

export const requestCommunityListSearchEpic = requestListSearchEpic(
    COMMUNITY_LIST_SEARCH_REQUEST,
    communityListRequest,
    "communities"
)

export const requestCommunityListFilterEpic = requestListFilterEpic(
    COMMUNITY_APPLY_FILTER_CRITERIA,
    communityListRequest,
    "communities"
)

export const requestCommunityItemEpic = requestItemEpic(
    COMMUNITY_ITEM_REQUEST,
    getCommunityItem,
    "communities",
    hydrateCommunity,
    normalisingFields,
    communityItemResponse,
    communityItemCachedResponse,
    communityItemErrorResponse
)

export const responseComunityListEpic = requestTopItemFromListResponseEpic(
    [COMMUNITY_LIST_RESPONSE, COMMUNITY_LIST_CACHED_RESPONSE],
    communityItemRequest,
    "communities",
    "communities",
    defaultSearchCriteria
)

export const communityAddNewEpic = action$ =>
    action$.ofType(COMMUNITY_ADD_NEW).map(() => communitySetEditMode(true))

export const requestCommunityApplyModelUpdateEpic = (action$, { getState }) =>
    action$.ofType(COMMUNITY_APPLY_MODEL_UPDATE).map(() => {
        const {
            activeId,
            updateModel,
            imageToUpload
        } = getState().presentation.communities
        let newUpdateModel = activeId
            ? updateModel.set("id", activeId)
            : updateModel
        return communityItemSaveRequest(
            activeId,
            communityToAPI(newUpdateModel).toJS(),
            imageToUpload
        )
    })

export const requestCommunityCancelModelUpdateEpic = (action$, { getState }) =>
    action$
        .ofType(COMMUNITY_CANCEL_MODEL_UPDATE)
        .map(() => getState().presentation.communities.activeId)
        .filter(id => id)
        .map(id => communityItemRequest(id))

export const requestCommunityItemSaveEpic = requestItemSaveEpic(
    COMMUNITY_ITEM_SAVE_REQUEST,
    putCommunityItem,
    postCommunityItem,
    "community",
    communityItemSaveResponse,
    communityItemErrorResponse
)

export const requestParticipantsForItemEpic = (action$, { getState }) =>
    action$
        .ofType(COMMUNITY_ITEM_REQUEST)
        .mergeMap(({ isInvalidating }) => {
            const state = getState()
            const {
                selectedParticipantType,
                activeId
            } = state.presentation.communities
            const paging =
                state.paging.communityParticipants[selectedParticipantType]
            let pagingRequest = paging[activeId] || {}
            const searchCriteria =
                pagingRequest.searchCriteria || Map({ name: "" })
            pagingRequest = {
                ...pagingRequest,
                nextOffset: 0,
                offset: 0,
                isInvalidating,
                searchCriteria: searchCriteria.set("communityId", activeId)
            }
            if (isInvalidating) {
                return Observable.of(
                    communityParticipantListInvalidation(activeId),
                    communityParticipantListRequest(
                        selectedParticipantType,
                        pagingRequest
                    )
                )
            } else
                return Observable.of(
                    communityParticipantListRequest(
                        selectedParticipantType,
                        pagingRequest
                    )
                )
        })

export const syncCommunityIdToURLEpic = syncIdToURLEpic(
    "communities",
    COMMUNITY_ITEM_RESPONSE,
    COMMUNITY_ITEM_CACHED_RESPONSE,
    COMMUNITY_ITEM_SAVE_RESPONSE
)
